// 事件总线，用于组件间通信
import Vue from 'vue'

export default new Vue()